import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import {
  userIsLogged,
  getRoute,
  apiDeleteConFile,
  apiGetConFileGetTipoContenuto,
  apiGetConFileGetAllFilesByFolder,
  apiDeleteConFolder,
  apiGetConFolderRipristina,
  apiGetConFileGetAllFiles,
  apiGetSvuotaCestino,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getValueByQueryString } from "../shared/manager/util";
import GestioneContenutiTree from "./GestioneContenutiTree";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneContenutiScreen() {
  const navigate = useNavigate();
  const [tipiContenuto, setTipiContenuto] = useState([]);
  const [rows, setRows] = useState([]);
  const [searchStringFilter, setSearchStringFilter] = useState("");
  const [tipoContenutoFilter, setTipoContenutoFilter] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteFolderDialogOpen, setDeleteFolderDialogOpen] = useState(false);
  const [emptyBinDialogOpen, setEmptyBinDialogOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [idFolderToDelete, setIdFolderToDelete] = useState(null);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  const { selectedLinguaTesto } = useLingueStore((state) => state);
  const breadCrumb = [
    { title: selectedLinguaTesto?.GestioneContenutiBreadcrumb1, link: null },
  ];

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  useEffect(() => {
    console.log(rows);
  }, [rows, selectedFolder]);

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 30)) {
        navigate("/");
      }
      initPage();
    }
  }

  function stopPage() {
    console.log("stopPage");
  }

  function initPage() {
    console.log("initPage");

    setPageTitle(selectedLinguaTesto?.GestioneContenutiPageTitle);
  
    apiGetConFileGetTipoContenuto(function (response) {
      let tipiList = [];
      let fileList = [];
      if (response != null && response.status >= 200 && response.status < 400) {
        tipiList = response.data;
      }
      let tipoContenutoQuery = getValueByQueryString("tipocontenuto");
      if (tipoContenutoQuery != null && tipoContenutoQuery != "") {
        setTipoContenutoFilter(tipoContenutoQuery);
      }
      apiGetConFileGetAllFiles(
        searchStringFilter,
        tipoContenutoFilter != null && tipoContenutoFilter != ""
          ? tipoContenutoFilter
          : tipoContenutoQuery != null
          ? tipoContenutoQuery
          : "",
        function (filesResp) {
          if (
            filesResp != null &&
            filesResp.status >= 200 &&
            filesResp.status < 400
          ) {
            fileList = filesResp.data;
          }

          setTipiContenuto(tipiList);
          setRows(fileList);
          console.log("tipiList", tipiList);
          console.log("fileList", fileList);
        }
      );
    });
  }

  function getTipoFileDesc(idTipoFile) {
    let desc = "";
    if (tipiContenuto != null && tipiContenuto.length > 0) {
      for (let i = 0; i < tipiContenuto.length; i++) {
        if (tipiContenuto[i].idTipoFile == idTipoFile) {
          desc = tipiContenuto[i].descTipoFile;
          break;
        }
      }
    }
    return desc;
  }

  const columns = [
    {
      field: "descFile",
      headerName: selectedLinguaTesto?.GestioneContenutiColumnDesc,
      flex: 2,
      sortable: true,
      headerClassName: "tableHeader",
    },
    {
      field: "tipoContenuto",
      headerName: selectedLinguaTesto?.GestioneContenutiColumnType,
      flex: 1,
      sortable: true,
      headerClassName: "tableHeader",
      renderCell: (params) => {
        let desc = getTipoFileDesc(params.row.tipoContenuto);

        return desc;
      },
    },
    {
      field: "pathFile",
      headerName: selectedLinguaTesto?.GestioneContenutiColumnFile,
      flex: 1,
      sortable: true,
      headerClassName: "tableHeader",
    },
    {
      field: "folderPath",
      headerName: selectedLinguaTesto?.GestioneContenutiColumnFolder,
      flex: 1,
      sortable: true,
      headerClassName: "tableHeader",
    },
    {
      field: "action",
      headerName: "",
      width: 160,
      sortable: false,
      headerClassName: "tableHeader",
      align: "right",
      renderCell: (params) => {
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking

          const action = event.target.dataset.action;
          if (action == "delete") {
            handleDelete(params.row.idFile);
          } else if (action == "edit") {
            handleEdit(params.row.idFile);
          } else if (action == "preview") {
            handlePreview(params.row.idFile);
          }
        };

        let showUp = params.row.ordine > 1;
        let showDown = params.row.ordine == 1;

        return (
          <div className="tableActionSmallButton">
            <img
              data-action="preview"
              src="/images/preview_btn.svg"
              title={selectedLinguaTesto?.GestioneContenutiImgPreview}
              onClick={onClick}
            />
            <img
              data-action="edit"
              src="/images/edit_btn.svg"
              title={selectedLinguaTesto?.GestioneContenutiImgEdit}
              onClick={onClick}
            />
            <img
              data-action="delete"
              src="/images/delete_btn.svg"
              title={selectedLinguaTesto?.GestioneContenutiImgDelete}
              onClick={onClick}
            />
          </div>
        );
      },
    },
  ];

  function findFileInRows(idFile) {
    if (rows != null && rows.length > 0) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].idFile == idFile) {
          return rows[i];
        }
      }
    }
    return null;
  }

  function handleNew() {
    const dest =
      "/contenuti/file?action=new&folder=" +
      (selectedFolder != null ? selectedFolder : 1);
    navigate(dest);
  }

  function handleNewAvatar() {
    const dest =
      "/contenuti/avatar?action=new&folder=" +
      (selectedFolder != null ? selectedFolder : 1);
    navigate(dest);
  }

  function handleEdit(idFile) {
    const dest = "/contenuti/file?action=edit&idfile=" + idFile;
    navigate(dest);
  }

  function handlePreview(idFile) {
    let file = findFileInRows(idFile);
    if (file != null && file.urlFile != null) {
      window.open(file.urlFile, "_blank");
    }
  }

  function handleDelete(idFile) {
    setIdToDelete(idFile);
    setDeleteDialogOpen(true);
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogConfirm = () => {
    setDeleteDialogOpen(false);
    apiDeleteConFile(idToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };

  function onTipoContenutoFilterChange(event) {
    let value = event.target.value;
    setTipoContenutoFilter(value);
  }

  function onSearchStringFilterChange(event) {
    let value = event.target.value;
    setSearchStringFilter(value);
  }

  function handleSearch() {
    initPage();
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      handleSearch();
    }
  }

  function folderActionCallback(action, folderId, path) {
    console.log("folderActionCallback=" + action + "  folder=" + folderId);
    console.log("folderActionCallback path", path);
    if (action != null) {
      if (action == "select") {
        onFolderSelect(folderId, path);
      } else if (action == "add") {
        navigate("/contenuti/folder/-1?parent=" + folderId);
      } else if (action == "edit") {
        navigate("/contenuti/folder/" + folderId);
      } else if (action == "del") {
        handleDeleteFolder(folderId);
      } else if (action == "undo") {
        handleUndoFolder(folderId);
      } else if (action == "trash") {
        handleEmptyBin(folderId);
      }
    }
  }

  function onFolderSelect(idFolder, path) {
    setSelectedFolder(idFolder);
    apiGetConFileGetAllFilesByFolder(
      idFolder,
      0,
      searchStringFilter,
      function (filesResp) {
        if (
          filesResp != null &&
          filesResp.status >= 200 &&
          filesResp.status < 400
        ) {
          let fileList = filesResp.data;
          setRows(fileList);
        }
      }
    );
  }

  function handleUndoFolder(idFolder) {
    apiGetConFolderRipristina(idFolder, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        if (selectedFolder != null) {
          setSelectedFolder(selectedFolder.idParentFolder);
        }
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  }

  function handleEmptyBin(idFolder) {
    setEmptyBinDialogOpen(true);
  }

  const handleEmptyBinDialogClose = () => {
    setEmptyBinDialogOpen(false);
  };

  function handleEmptyBinDialogConfirm(idFolder) {
    setEmptyBinDialogOpen(false);

    apiGetSvuotaCestino(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        setSelectedFolder(1);
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  }

  function handleDeleteFolder(idFolder) {
    setIdFolderToDelete(idFolder);
    setDeleteFolderDialogOpen(true);
  }

  const handleDeleteFolderDialogClose = () => {
    setDeleteFolderDialogOpen(false);
  };

  const handleDeleteFolderDialogConfirm = () => {
    setDeleteFolderDialogOpen(false);
    apiDeleteConFolder(idFolderToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        if (selectedFolder != null) {
          setSelectedFolder(selectedFolder.idParentFolder);
        }
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };

  function handleContenutiAgent() {
    navigate("/contenuti/agent/list");
  }

  return (
    <div id="avp-gestionecontenuti-screen">
      <AvpHeader selectedMenuId={"contenuti"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#contenuti"} />
      <div id="avp-cms-screen-container" className="clearfix">
        <Collapse
          in={alertSuccessOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setAlertSuccessOpen(false);
            }, 2000);
          }}
        >
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneContenutiAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneContenutiAlertError}
          </Alert>
        </Collapse>

        <div className="avp-cms-screen-title">{pageTitle}</div>
        <div className="avp-cms-screen-content clearfix">
          <div className="avp-cms-screen-toolbar clearfix">
            <div className="avp-cms-screen-toolbar-title">
              {rows.length}&nbsp;
              {selectedLinguaTesto?.GestioneContenutiPageSubtitle}
            </div>
            <div className="avp-cms-screen-toolbar-filters"></div>
            <div
              className="avp-cms-screen-toolbar-add"
              onClick={handleContenutiAgent}
              style={{ marginLeft: "20px" }}
            >
              <button>
                {selectedLinguaTesto?.GestioneContenutiButtonGoToAgent}
              </button>
            </div>
            <div
              className="avp-cms-screen-toolbar-add"
              onClick={handleNewAvatar}
              style={{ marginLeft: "20px" }}
            >
              <button>
                {selectedLinguaTesto?.GestioneContenutiCreateAvatar}
              </button>
            </div>
            <div
              className="avp-cms-screen-toolbar-add"
              onClick={handleNew}
              style={{ marginLeft: "20px" }}
            >
              <button>
                {selectedLinguaTesto?.GestioneContenutiNewContent}
              </button>
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-tipofile">
                {selectedLinguaTesto?.GestioneContenutiTitle}
              </label>
              <br />
              <select
                id="avp-form-tipofile"
                defaultValue={tipoContenutoFilter}
                onChange={onTipoContenutoFilterChange}
              >
                <option key={-1} value="">
                  {selectedLinguaTesto?.GestioneContenutiOptionAll}
                </option>
                {tipiContenuto != null && tipiContenuto.length > 0 ? (
                  tipiContenuto.map((item, i) => {
                    return (
                      <option key={item.idTipoFile} value={item.idTipoFile}>
                        {item.descTipoFile}
                      </option>
                    );
                  })
                ) : (
                  <option></option>
                )}
              </select>
            </div>

            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-pathfile">
                {selectedLinguaTesto?.GestioneContenutiSearchLabel}
              </label>
              <br />
              <input
                id="avp-form-pathfile"
                type="text"
                value={searchStringFilter}
                onChange={onSearchStringFilterChange}
                onKeyDown={handleKeyDown}
              />
            </div>

            <div className="avp-cms-screen-content-column">
              <button
                onClick={handleSearch}
                style={{
                  borderRadius: "10px",
                  height: "34px",
                  marginTop: "20px",
                }}
              >
                {selectedLinguaTesto?.GestioneContenutiButtonSearch}
              </button>
            </div>
          </div>

          <div id="avp-cms-contenuti-screen-box" className="clearfix">
            <div
              id="avp-cms-contenuti-screen-box-tree"
              style={{ position: "relative", float: "left", width: "30%" }}
            >
              <GestioneContenutiTree
                actionCallback={folderActionCallback}
                showToolbar={true}
                initialFolder={selectedFolder != null ? selectedFolder : 1}
                showInitialFolder={true}
                autoExpandToSelection={true}
                showBin={true}
              />
            </div>
            <div
              id="avp-cms-contenuti-screen-box-list"
              style={{ position: "relative", float: "left", width: "70%" }}
            >
              <Box sx={{ width: "100%" }}>
                <DataGrid
                  disableColumnMenu
                  getRowId={(row) => row.idFile}
                  rows={rows}
                  columns={columns}
                  getRowClassName={(params) => "tableRow"}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 10,
                      },
                    },
                  }}
                  pageSizeOptions={[10, 20, 30, 40]}
                  disableRowSelectionOnClick
                  autoheight
                />
              </Box>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {selectedLinguaTesto?.GestioneContenutiDialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.GestioneContenutiDialogDeleteText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>
            {selectedLinguaTesto?.GestioneContenutiDialogUndo}
          </Button>
          <Button onClick={handleDeleteDialogConfirm} autoFocus>
            {selectedLinguaTesto?.GestioneContenutiDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteFolderDialogOpen}
        onClose={handleDeleteFolderDialogClose}
        aria-labelledby="alert-folder-dialog-title"
        aria-describedby="alert-folder-dialog-description"
      >
        <DialogTitle id="alert-folder-dialog-title">
          {"Conferma eliminazione"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-folder-dialog-description">
            {selectedLinguaTesto?.GestioneContenutiDialogDeleteFolder}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteFolderDialogClose}>
            {selectedLinguaTesto?.GestioneContenutiDialogUndo}
          </Button>
          <Button onClick={handleDeleteFolderDialogConfirm} autoFocus>
            {selectedLinguaTesto?.GestioneContenutiDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={emptyBinDialogOpen}
        onClose={handleEmptyBinDialogClose}
        aria-labelledby="alert-folder-dialog-title"
        aria-describedby="alert-folder-dialog-description"
      >
        <DialogTitle id="alert-folder-dialog-title">
          {"Conferma eliminazione"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-folder-dialog-description">
            {selectedLinguaTesto?.GestioneContenutiDialogDeleteTrash}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEmptyBinDialogClose}>
            {selectedLinguaTesto?.GestioneContenutiDialogUndo}
          </Button>
          <Button onClick={handleEmptyBinDialogConfirm} autoFocus>
            {selectedLinguaTesto?.GestioneContenutiDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
